export const exceptions403List = ["/api/kpi-dashboard"];

export const SESSION_WARNING_THRESHOLD_MS = 120000;
